import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { RootState } from '../store/store';

const API_HOST = process.env.REACT_APP_API_HOST;

export interface Notification {
  _id?: string;
  title?: string;
  message?: string;
  type?: string;
  isRead?: boolean;
  createdAt?: string;
  // Додайте інші поля сповіщення
  [key: string]: any;
}

export interface NotificationCreateRequest {
  title: string;
  message: string;
  type?: string;
  userIds?: string[];
  // Додайте інші поля для створення
  [key: string]: any;
}

export const notificationApi = createApi({
  reducerPath: 'notificationApi',
  baseQuery: fetchBaseQuery({
    baseUrl: API_HOST,
    credentials: 'include',
    prepareHeaders: async (headers, { getState }) => {
      const token = (getState() as RootState).user.info?.api_token;
      if (token) {
        headers.set('Authorization', `Bearer ${token}`);
      }
      return headers;
    },
  }),
  tagTypes: ['Notification'],
  endpoints: (build) => ({
    getNotifications: build.query<{ data: Notification[]; total: number }, { page?: number; limit?: number; isRead?: boolean }>({
      query: (params) => {
        const query = new URLSearchParams();
        if (params.page) query.append('page', params.page.toString());
        if (params.limit) query.append('limit', params.limit.toString());
        if (params.isRead !== undefined) query.append('isRead', params.isRead.toString());
        
        return {
          url: `notification/list?${query.toString()}`,
          method: 'GET',
        };
      },
      providesTags: ['Notification'],
    }),
    
    getNotificationCount: build.query<{ unread: number }, void>({
      query: () => ({
        url: 'notification/list',
        method: 'GET',
      }),
      providesTags: ['Notification'],
    }),
    
    createNotification: build.mutation<Notification, NotificationCreateRequest>({
      query: (data) => ({
        url: 'notification',
        method: 'POST',
        body: data,
      }),
      invalidatesTags: ['Notification'],
    }),
    
    markAsRead: build.mutation<void, string>({
      query: (id) => ({
        url: `notification/${id}/read`,
        method: 'PATCH',
      }),
      invalidatesTags: ['Notification'],
    }),
    
    markAllAsRead: build.mutation<void, void>({
      query: () => ({
        url: 'notification/read-all',
        method: 'PATCH',
      }),
      invalidatesTags: ['Notification'],
    }),
    
    deleteNotification: build.mutation<void, string>({
      query: (id) => ({
        url: `notification/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['Notification'],
    }),
  }),
});

export const {
  useGetNotificationsQuery,
  useGetNotificationCountQuery,
  useCreateNotificationMutation,
  useMarkAsReadMutation,
  useMarkAllAsReadMutation,
  useDeleteNotificationMutation,
} = notificationApi; 